exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-2c3f65b5]{-webkit-appearance:none;padding:.5rem 3.25rem .5rem 1rem;box-sizing:border-box;border-radius:.5rem}", ""]);

// exports
